import { BaseFetch } from "../main-model"
export default class SubClassTimeModel extends BaseFetch {
  getSubClassTimeBy = (data) =>
    this.authFetch({
      url: "sub-class-time/getSubClassTimeBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getSubClassTimeById = (data) =>
    this.authFetch({
      url: "sub-class-time/getSubClassTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateSubClassTimeById = (data) =>
    this.authFetch({
      url: "sub-class-time/updateSubClassTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertSubClassTime = (data) =>
    this.authFetch({
      url: "sub-class-time/insertSubClassTime",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteSubClassTimeById = (data) =>
    this.authFetch({
      url: "sub-class-time/deleteSubClassTimeById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
